import React, {
 createContext, useContext, useEffect, useRef, useState
} from 'react';
import Pusher from 'pusher-js';
import PropTypes from 'prop-types';

const PusherContext = createContext({ pusher: null });

export const PusherProvider = ({ children }) => {
  const pusherRef = useRef(null);
  const [pusherReady, setPusherReady] = useState(false);
  
  useEffect(() => {
    // Якщо юзер є і Pusher ще не створений
    if (!pusherRef.current) {
      const { token = '' } = JSON.parse(localStorage.getItem('token', {})) || {};
      const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
        cluster: 'us2',
        channelAuthorization: {
          endpoint: `${process.env.REACT_APP_MAIN_API_URL}/pusher/auth`,
          headers: {
            Authorization: `Bearer ${token}`,

          }
        },
        userAuthentication: {
          endpoint: `${process.env.REACT_APP_MAIN_API_URL}/pusher/user-auth`,
          headers: {
            Authorization: `Bearer ${token}`,
          }
        },
      });
      pusherRef.current = pusher;
      pusher.logToConsole = true; // Для налагодження, можна видалити в продакшн
      pusherRef.current.signin();
      setPusherReady(true);
    }

    return () => {
      if (pusherRef.current) {
        pusherRef.current.disconnect();
        pusherRef.current = null;
        setPusherReady(false);
      }
    };
  }, []);

  return (
    <PusherContext.Provider value={{ pusher: pusherRef.current, pusherReady }}>
      {children}
    </PusherContext.Provider>
  );
};

PusherProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const usePusher = () => useContext(PusherContext);
